module.exports = __webpack_public_path__ + "static/media/stat547u_lecture04.2af15a85.pdf";